import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=0d168a34&scoped=true&"
import script from "./MobileView.vue?vue&type=script&lang=js&"
export * from "./MobileView.vue?vue&type=script&lang=js&"
import style0 from "./MobileView.vue?vue&type=style&index=0&id=0d168a34&scoped=true&lang=css&"
import style1 from "./MobileView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d168a34",
  null
  
)

export default component.exports